import React from 'react';
import { Link } from 'react-router-dom';

class SideBar extends React.Component
{
    render()
    {
        return(
                <div className="Sidebar">
                <Link to="/" className="item">
                    Home
                </Link>
                <Link to="/about" className="item">
                    Faulty Agatha
                </Link>
                <Link to="/webgl" className="item">
                    WebGL Playground
                 </Link>   
                <Link to="/projects" className="item">
                    Projects
                </Link>
                <Link to="/contacts" className="item">
                    Poke Me
                </Link>
                <p></p>
                <p></p>
                <a
                href="https://github.com/faultyagatha" 
                title="Follow on Github">
                <i className="github alternate icon"></i>
                </a>
                <a
                href="https://www.instagram.com/faultyagatha" 
                title="Follow on Instagram">
                <i className="instagram icon"></i>
                </a> 
                <a
                href="https://vimeo.com/faultyagatha" 
                title="Follow on Vimeo">
                <i className="vimeo v icon"></i>
                </a>      
             </div> 
        );
    };
};

export default SideBar;